import React from "react"
import { Modal, Button } from "@mui/material"

import * as S from "./styles"

const CustomModal = ({ open, onClose, children, title }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <S.ContainerModal>
        <S.HeaderModal>
          <S.TitleModal>{title}</S.TitleModal>
        </S.HeaderModal>

        <S.ContentModal>{children}</S.ContentModal>

        <S.FooterModal>
          <Button onClick={onClose} variant="outlined">
            Fechar
          </Button>
        </S.FooterModal>
      </S.ContainerModal>
    </Modal>
  )
}

export default CustomModal
